export default __webpack_public_path__ + "static/media/allgemein_30.5430e68d.jpg";